module.exports = __webpack_public_path__ + "img/about-mission.d7c74e96.png";